import { render } from "./_base-checkbox-group.vue?vue&type=template&id=5737858d"
import script from "./_base-checkbox-group.vue?vue&type=script&lang=js"
export * from "./_base-checkbox-group.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./_base-checkbox-group.vue?vue&type=style&index=0&id=5737858d&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__